import { render, staticRenderFns } from "./Proforma-Invoice-View.vue?vue&type=template&id=4b207214"
import script from "./Proforma-Invoice-View.vue?vue&type=script&lang=js"
export * from "./Proforma-Invoice-View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports